module.exports = __webpack_public_path__ + "img/ai.9bf5af0b.svg";